import script from "./AMensagemDeErro.vue?vue&type=script&setup=true&lang=ts"
export * from "./AMensagemDeErro.vue?vue&type=script&setup=true&lang=ts"

import "./AMensagemDeErro.vue?vue&type=style&index=0&id=59a4d7bd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a4d7bd"]])

export default __exports__